import MainContent from "./MainContent";
import About from ".//About";

const MenuPertama = () => {
  return (
    <div className="MainContent">
      <div className="Main">
        <MainContent />
      </div>
      <div className="About">
        <About />
      </div>
    </div>
  );
};

export default MenuPertama;
